/**
 * The DOM attribute to mark impression container elements.
 * @const {string}
 */
export const CONTAINER_ID_ATTR = 'data-container-id';

/**
 * The DOM attribute to mark impression item elements.
 * @const {string}
 */
export const IMPRESSION_ITEM_ATTR = 'data-impression-item';

/**
 * The DOM attribute to mark impression item's parent id.
 * @const {string}
 */
export const IMPRESSION_PARENT_ATTR = 'data-parent-id';

/**
 * The DOM attribute to mark an item that overflows container.
 * @const {boolean}
 */
export const OVERFLOWED_ITEM_ATTR = 'overflowed-item';

/**
 * The DOM attribute to mark impression containers elements.
 * @const {string}
 */
export const ITEM_WITHOUT_CONTAINER_SELECTOR = `[${IMPRESSION_ITEM_ATTR}]:not([${IMPRESSION_PARENT_ATTR}])`;

/**
 * The DOM attribute to mark an item that already impressed.
 * @const {boolean}
 */
export const IMPRESSED_ITEM_ATTR = 'impressed-item';
